<template>
	<div>
		<i class="icon icon-novo_cadastro"></i>
		<h3>{{ tituloCabecalho.toUpperCase() }}</h3>
		<h4 @click="_exibeSub(submenuModulo)" class="titulo_h4">
			{{ subTituloCabecalho.toUpperCase() }}
			<i class="fa fa-angle-down" aria-hidden="true"></i>
		</h4>
	</div>
</template>

<script>
export default {
	props: {
		titulo: {
			type: String,
			required: true
		},
		subTitulo: {
			type: String,
			required: true
		},
		submenuModulo: {
			type: String,
			default: 'ad'
		}
	},

	computed: {
		tituloCabecalho() {
			return this.titulo || this._traducao('global', 'cadastroUnidadeArmazenamento')
		},

		subTituloCabecalho() {
			return this.subTitulo || `${this._traducao('menu', 'menuAdministracao')} ${this._traducao('menu', 'menuGeral')}`
		}
	}
}
</script>

<style scoped>
.titulo_h4 {
	cursor: pointer;
}
</style>
